<template>
  <v-select
    v-model="selectedMinDate"
    outlined
    dense
    :hide-details="true"
    label="Filter"
    :items="dateOptions"
    @change="$emit('input', $event)"
  ></v-select>
</template>
<script>
import moment from 'moment'

export default {
  data() {
    return {
      selectedMinDate: null,
      dateOptions: [
        { text: 'All', value: null },
        {
          text: '1 month',
          value: moment()
            .subtract(1, 'months')
            .startOf('day')
        },
        {
          text: '3 months',
          value: moment()
            .subtract(3, 'months')
            .startOf('day')
        },
        {
          text: '6 months',
          value: moment()
            .subtract(6, 'months')
            .startOf('day')
        },
        {
          text: '1 year',
          value: moment()
            .subtract(1, 'year')
            .startOf('day')
        },
        {
          text: '2 years',
          value: moment()
            .subtract(2, 'years')
            .startOf('day')
        }
      ]
    }
  }
}
</script>
